import React from 'react';
import Button, { ButtonType } from '../common/Button';
import { CurveType, SpecialPointType } from '../../enums';
import { useAppSelector } from '../../hooks/common';
import { CommonParameters, CurrentData, InputData, LoadData } from '../../models';
import { useHook } from '../../hooks';
import { InnoButton } from '@innomotics/innomotics-build-react-lib';

const DebugData = () => {
    const calculationResponse = useAppSelector(state => state.motor.calculationResponse);
    const { onExportPointsClick } = useHook(x => x.debugData)();

    const renderSections = () => {
        if (calculationResponse) {
            const { mesParameters, curveData, operatingValues, messages } = calculationResponse;
            const { commonParameters, inputData } = mesParameters;
            const loadCurve = curveData.find(x => x.type === CurveType.Load);
            const loadSwitchingPoint = loadCurve && loadCurve.expandedSpecialPoints && loadCurve.expandedSpecialPoints.length &&
                loadCurve.expandedSpecialPoints.find(x => x.type === SpecialPointType.LoadSwitching);

            const inputDataArray = Object.keys(inputData)
                .map(key => key !== 'loadData' && key !== 'currentData' && `${key}: ${inputData[key as keyof InputData]}`);

            const loadDataArray = Object.keys(inputData.loadData as LoadData).map(key => `${key}: ${inputData.loadData[key as keyof LoadData]}`);

            const currentDataArray = Object.keys(inputData.currentData).map(key => `${key}: ${inputData.currentData[key as keyof CurrentData]}`);

            const commonParametersArray = Object.keys(commonParameters).map(key => [`${key}: ${commonParameters[key as keyof CommonParameters]}`]);

            const accelerationTorqueCurve = curveData.find(x => x.type === CurveType.AccelerationTorque);
            const accelerationTorqueCurveAverage = accelerationTorqueCurve
                ? accelerationTorqueCurve.points.yPoints.reduce((sum, x) => sum + x, 0) / accelerationTorqueCurve.points.yPoints.length
                : null;

            return (
                <>
                    <div className='section'>
                        <div className='section-title'>Calculation input</div>
                        <ul>
                            {inputDataArray.map((value, index) => <li key={index}>{value}</li>)}
                        </ul>
                    </div>
                    <div className='section'>
                        <div className='section-title'>Load data</div>
                        <ul>
                            {loadDataArray.map((value, index) => <li key={index}>{value}</li>)}
                        </ul>
                    </div>
                    <div className='section'>
                        <div className='section-title'>Current data</div>
                        <ul>
                            {currentDataArray.map((value, index) => <li key={index}>{value}</li>)}
                        </ul>
                    </div>
                    <div className='section'>
                        <div className='section-title'>Common parameters</div>
                        <ul>
                            {commonParametersArray.map((value, index) => <li key={index}>{value}</li>)}
                        </ul>
                    </div>
                    <div className='section'>
                        <div className='section-title'>Additional infos</div>
                        <ul>
                            {operatingValues.loadVoltage1 &&
                                <li>Operating Voltage 100%: {operatingValues.loadVoltage1} [V]</li>
                            }
                            {operatingValues.loadVoltage2 &&
                                <li>Operating Voltage {inputData['startingVoltage'] * 100}%: {operatingValues.loadVoltage2} [V]</li>
                            }
                            {operatingValues.loadPower &&
                                <li>Operating Power: {operatingValues.loadPower} [kW]</li>
                            }
                            {operatingValues.loadTorque &&
                                <li>Operating Torque: {operatingValues.loadTorque} [Nm]</li>
                            }
                            {operatingValues.loadSpeed &&
                                <li>Operating Speed: {operatingValues.loadSpeed} [rpm]</li>
                            }
                            {operatingValues.loadCurrent &&
                                <li>Operating Current: {operatingValues.loadCurrent} [A]</li>
                            }
                            {accelerationTorqueCurveAverage &&
                                <li>Acceleration torque curve average: {accelerationTorqueCurveAverage}</li>
                            }
                            {loadSwitchingPoint &&
                                <li>Load Switching point [Star Delta] x: {loadCurve.expandedPoints.xPoints[loadSwitchingPoint.index]} y: {loadCurve.expandedPoints.yPoints[loadSwitchingPoint.index]}</li>
                            }
                        </ul>
                    </div>
                    <div className='section'>
                        <div className='section-title'>DOL messages</div>
                        <ul>
                            {messages && messages.map((msg, i) => <li key={i}>{msg.debugMessage}</li>)}
                        </ul>
                    </div>
                    <div className='section'>
                        <InnoButton variant='primary' onClick={onExportPointsClick}>Export points</InnoButton>
                    </div>
                </>
            );
        }
    };

    return (
        <div className='debug-container'>
            <div className='debug-data'>
                <div className='title'>Debug data</div>
                {renderSections()}
            </div>
        </div>
    );
};

export default DebugData;
